export default "__VITE_PUBLIC_ASSET__3c087b7b__"